import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import { applySafariSquircleFallbackClass } from './utils/squircleCompat';
import App from './App';
import reportWebVitals from './reportWebVitals';

applySafariSquircleFallbackClass();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

reportWebVitals();